<mat-icon svgIcon="view-off" class="kpis-zero-icon"></mat-icon>
<span class="kpis-zero-header">Where are my KPIs?</span>
<span class="kpis-zero-text">Expand at least one of the stages in the Milestone viewer above.</span>
